import { render } from "./SysDirManage.vue?vue&type=template&id=6c3e1883&scoped=true"
import script from "./SysDirManage.vue?vue&type=script&lang=js"
export * from "./SysDirManage.vue?vue&type=script&lang=js"

import "./SysDirManage.vue?vue&type=style&index=0&id=6c3e1883&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3e1883"]])

export default __exports__